import type { ApiErrorResponse } from './types'
import type { StructuredApiErrorResponse } from '@/shared/lib/utils/errorHandler'

/**
 * A custom error class that holds the response object and status.
 * TanStack Query will receive this error on promise rejection.
 */
export class HttpError extends Error {
  response: Response
  status: number
  method: string
  url: string
  errorData?: ApiErrorResponse | StructuredApiErrorResponse

  constructor(response: Response, method = 'GET', url = response.url) {
    super(`HTTP Error: ${response.status} ${response.statusText}`)
    this.name = 'HttpError'
    this.response = response
    this.status = response.status
    this.method = method
    this.url = url
  }

  /**
   * Parse the error response JSON
   * @returns Promise with the parsed error data (can be either format)
   */
  async parseError(): Promise<
    ApiErrorResponse | StructuredApiErrorResponse | null
  > {
    try {
      const errorData = (await this.response.clone().json()) as
        | ApiErrorResponse
        | StructuredApiErrorResponse
      this.errorData = errorData
      return errorData
    }
    catch (e) {
      console.error('Failed to parse error response', e)
      return null
    }
  }
}
